import React, { useEffect } from "react";
import { Container, } from "react-bootstrap";
import { connect } from "react-redux";
import { DeleteJobApi, UpdateJobApi, GetJobWithIdApi, UpdateJobStatusApi } from "./JobAction";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import { useNavigate, useLocation } from "react-router-dom";
import MaterialSize from "material-table";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PrintIcon from '@mui/icons-material/Print';
import { GenerateLOE } from "../LOE_PDF/LOE";
const tableRef = React.createRef()


const ViewJob = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const permissions = JSON.parse(window.localStorage.getItem("permissions"));
    const Checkpermissions = (permissionsType, permissionsName) => {
        return permissions.some((p) => p[`${permissionsType}`] === permissionsName) ? false : true;
    };

    useEffect(() => {
        props.setHeading("Job List");
    }, []);

    return (
        <>
            <Container fluid>
                <MaterialSize
                    title="Job List"
                    tableRef={tableRef}
                    columns={[
                        { title: 'Sequence Number', field: 'sequenceNumber', editable: 'never' },
                        { title: "Client", field: "customerId.companyName", editable: 'never' },
                        { title: "Service", field: "productId.productName", editable: 'never' },
                        { title: "Team Member", field: "teamMemberId.name", editable: 'never' },
                        { title: "Job Status", field: "jobStatus", editable: 'never' },
                        { title: "Start Date", field: "startDate" },
                        { title: "End Date", field: "endDate" },
                        { title: "Invoice Number", field: "invoiceNumber" },
                        { title: "Financial Year", field: "financialYear" },
                        { title: "Financial Month", field: "financialMonth" },
                        { title: "Fee", field: "fee" },
                        { title: "VAT", field: "vat" },
                        { title: "Job Fee", field: "jobFee" },
                        {
                            title: "Fee Status", field: "feeStatus", editable: 'never',
                            render: (rowData) => (
                                <div
                                    style={{
                                        backgroundColor: rowData.feeStatus === "Paid" ? "#9FD983" : rowData.feeStatus === "UnPaid" ? "#F8B8A2" : "#F8B8A2",
                                        padding: "5px 16px 7px",
                                        borderRadius: "10px",
                                        textAlign: "center",
                                        width: "max-content"
                                    }}
                                >
                                    {rowData.feeStatus}
                                </div>
                            ),
                        },
                        { title: "Created By", field: "userDetails.userName", editable: 'never' },
                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/job?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + (query.page);
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: "GET",
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    options={{
                        actionsColumnIndex: -1,
                        exportButton: true,
                        exportAllData: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200],
                        headerStyle: {
                            position: "sticky",
                            top: 0,
                            color: "#00BBBB",
                            fontWeight: "550",
                            onRowAdd: "none",
                        },
                    }}
                    editable={{
                        // isEditHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Colour Edit"),
                        // isDeleteHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Colour Delete"),
                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.UpdateJobApi(newData, oldData);
                                }, 600);
                            }),
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.DeleteJobApi(oldData._id);
                                }, 600);
                            }),
                    }}
                    actions={[
                        {
                            icon: 'refresh',
                            tooltip: 'Refresh Data',
                            isFreeAction: true,
                            onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                        },
                        (rowData) => ({
                            icon: () => <UploadFileIcon />,
                            tooltip: "Upload Documents",
                            onClick: async (event, rowData) => {
                                navigate(`/crm/job/UploadDocument/${rowData._id}`);
                                props.GetJobWithIdApi(rowData._id)
                            },
                        }),
                        (rowData) => ({
                            hidden: Checkpermissions("permissionsSubCatName", "Upload Job Document"),
                            icon: () => <VisibilityIcon />,
                            tooltip: "Job Preview",
                            onClick: (event, rowData) => {
                                navigate("/crm/job/DetailJobView", {
                                    state: {
                                        fromPath: location.pathname,
                                        JobViewDetails: rowData,
                                    },
                                });
                            },
                        }),
                        (rowData) => ({
                            // hidden: Checkpermissions("permissionsSubCatName", "Voucher Approvel Permission") === true ? false : true,
                            disabled: rowData.feeStatus === 'UnPaid' ? false : true,
                            icon: () => <TaskAltIcon style={{ color: rowData.feeStatus === 'UnPaid' ? 'green' : '#cccccc' }} />,
                            tooltip: "Fee Paid",
                            onClick: (event, rowData) => {
                                const status = 'Paid'
                                props.UpdateJobStatusApi(rowData._id, status);
                                tableRef.current && tableRef.current.onQueryChange();
                            },
                        }),
                        (rowData) => ({
                            icon: () => <PrintIcon />,
                            tooltip: "LOE",
                            onClick: (event, rowData) => {
                                GenerateLOE(rowData)
                            },
                        }),
                    ]}
                />
            </Container>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        DeleteJobApi: (id) => dispatch(DeleteJobApi(id)),
        UpdateJobApi: (newData, oldData) => dispatch(UpdateJobApi(newData, oldData)),
        UpdateJobStatusApi: (jobId, status) => dispatch(UpdateJobStatusApi(jobId, status)),
        GetJobWithIdApi: (id) => dispatch(GetJobWithIdApi(id)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingJob: state.JobReducer.isFetchingJob,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewJob);